module.exports = __webpack_public_path__ + "static/img/rppghealthappbs1.f009ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthappbs1.png
// module id = 3Pej
// module chunks = 4